import * as ko from 'knockout';

const allowBindingsHandler = {
    init: (element, valueAccessor) => {
        const shouldAllowBindings = ko.unwrap(valueAccessor());
        return { controlsDescendantBindings: !shouldAllowBindings };
    },
};
// binding auto registration
ko.bindingHandlers.allowBindings = allowBindingsHandler;